export default {
  "hierarchy": {
    "title": [
      "text-title"
    ],
    "subtitle": [
      "text-subtitle"
    ],
    "body": [
      "text-body"
    ],
    "bodySmall": [
      "text-bodySmall"
    ],
    "caption": [
      "text-caption"
    ],
    "captionSmall": [
      "text-captionSmall"
    ],
    "navLogoLabel": [
      "text-subtitle",
      "text-navLogoLabel"
    ],
    "pageTitle": [
      "text-title",
      "text-pageTitle"
    ],
    "sectionTitle": [
      "text-title",
      "text-sectionTitle"
    ],
    "sectionBody": [
      "text-bodySmall",
      "text-sectionBody"
    ],
    "cardTitle": [
      "text-subtitle",
      "text-cardTitle"
    ],
    "formTitle": [
      "text-title",
      "text-formTitle"
    ],
    "formSubtitle": [
      "text-subtitle",
      "text-formSubtitle"
    ],
    "formBody": [
      "text-body",
      "text-formBody"
    ],
    "listItemTitle": [
      "text-subtitle",
      "text-listItemTitle"
    ],
    "listItemSubtitle": [
      "text-caption",
      "text-listItemSubtitle"
    ],
    "inputCaptionSmall": [
      "text-captionSmall",
      "text-inputCaptionSmall"
    ],
    "inputCaptionSmallError": [
      "text-captionSmall",
      "text-inputCaptionSmall",
      "text-inputCaptionSmallError"
    ],
    "loginWarning": [
      "text-bodySmall",
      "text-loginWarning"
    ],
    "mobileMapTitle": [
      "text-bodySmall",
      "text-mobileMapTitle"
    ],
    "mobileTitle": [
      "text-bodySmall",
      "text-mobileTitle"
    ],
    "captionBold": [
      "text-captionBold"
    ],
    "captionSmallBold": [
      "text-captionSmallBold"
    ],
    "toastTitle": [
      "text-subtitle",
      "text-toastTitle"
    ],
    "toastMsg": [
      "text-caption",
      "text-toastMsg"
    ],
    "detailTitle": [
      "text-subtitle",
      "text-detailTitle"
    ],
    "detailLabel": [
      "text-bodySmall",
      "text-detailLabel"
    ],
    "detailValue": [
      "text-bodySmall",
      "text-detailValue"
    ],
    "detailSuffix": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailSuffix"
    ],
    "screenTitle": [
      "text-title",
      "text-screenTitle"
    ],
    "dialogTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle"
    ],
    "sideNav": [
      "text-sideNav"
    ],
    "loginLogo": [
      "text-loginLogo"
    ],
    "listDetailTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-listDetailTitle"
    ],
    "mobileUserNavBar": [
      "text-mobileUserNavBar"
    ],
    "groupTitle": [
      "text-captionSmall",
      "text-groupTitle"
    ],
    "dashboardCardTitle": [
      "text-subtitle",
      "text-dashboardCardTitle"
    ],
    "dashboardCardEditorTitle": [
      "text-subtitle",
      "text-dashboardCardTitle",
      "text-dashboardCardEditorTitle"
    ],
    "rootEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle"
    ],
    "actionBar": [
      "text-actionBar"
    ],
    "sideNavBarHeader": [
      "text-captionBold",
      "text-sideNavBarHeader"
    ],
    "networkOffline": [
      "text-networkOffline"
    ],
    "sideNavSmall": [
      "text-sideNav",
      "text-sideNavSmall"
    ],
    "linearViewHeaderCell1": [
      "text-linearViewHeaderCell1"
    ],
    "linearViewHeaderCell2": [
      "text-linearViewHeaderCell2"
    ],
    "pairingErrorSubtitle": [
      "text-pairingErrorSubtitle"
    ],
    "bodyCentered": [
      "text-bodyCentered"
    ],
    "resendSuccess": [
      "text-resendSuccess"
    ],
    "twoFactorWarning": [
      "text-twoFactorWarning"
    ],
    "pill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill"
    ],
    "pillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary"
    ],
    "pillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess"
    ],
    "pillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning"
    ],
    "pillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError"
    ],
    "resendCodeSuccess": [
      "text-resendCodeSuccess"
    ],
    "twoStepTitle": [
      "text-twoStepTitle"
    ],
    "hint": [
      "text-hint"
    ],
    "columnValue": [
      "text-columnLabel",
      "text-columnValue"
    ],
    "columnLabel": [
      "text-columnLabel"
    ],
    "conditionTitle": [
      "text-bodySmall",
      "text-conditionTitle"
    ],
    "missingRelTitle": [
      "text-missingRelTitle"
    ],
    "expressionParen": [
      "text-expressionParen"
    ],
    "operatingHoursTitle": [
      "text-operatingHoursTitle"
    ],
    "hintSmall": [
      "text-hint",
      "text-hintSmall"
    ],
    "aggregationTitle": [
      "text-bodySmall",
      "text-detailLabel",
      "text-aggregationTitle"
    ],
    "aggregationLabel": [
      "text-aggregationLabel"
    ],
    "aggregationValue": [
      "text-subtitle",
      "text-aggregationValue"
    ],
    "overrideExample": [
      "text-overrideExample"
    ],
    "editorTitle": [
      "text-subtitle",
      "text-editorTitle"
    ],
    "conditionAttributeLabel": [
      "text-conditionAttributeLabel"
    ],
    "info": [
      "text-twoFactorWarning",
      "text-info"
    ],
    "conditionPropertyComparatorValue": [
      "text-conditionPropertyComparatorValue"
    ],
    "comparator": [
      "text-comparator"
    ],
    "tagError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tagError"
    ],
    "captionCurrent": [
      "text-caption",
      "text-captionCurrent"
    ],
    "tableConditionAttributeLabel": [
      "text-tableConditionAttributeLabel"
    ],
    "mobileNavSubtitle": [
      "text-mobileNavSubtitle"
    ],
    "navSecondaryMobileTitle": [
      "text-navSecondaryMobileTitle"
    ],
    "navSecondaryMobileHeader": [
      "text-navSecondaryMobileHeader"
    ],
    "mobileScreenTitle": [
      "text-mobileScreenTitle"
    ],
    "mobileOptNavTitle": [
      "text-mobileOptNavTitle"
    ],
    "mobileNavBarHeader": [
      "text-mobileNavBarHeader"
    ],
    "ruleTrigger": [
      "text-ruleTrigger"
    ],
    "ruleBlockTitle": [
      "text-ruleBlockTitle"
    ],
    "ruleBlockDescription": [
      "text-ruleBlockDescription"
    ],
    "captionLeft": [
      "text-caption",
      "text-captionLeft"
    ],
    "linkTable": [
      "text-linkTable"
    ],
    "pillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus"
    ],
    "pillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood"
    ],
    "pillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert"
    ],
    "value": [
      "text-columnLabel",
      "text-columnValue",
      "text-value"
    ],
    "valueGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueGood"
    ],
    "valueAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueAlert"
    ],
    "valueOffline": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueOffline"
    ],
    "valueLowBattery": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueLowBattery"
    ],
    "dashboardGridCardTitle": [
      "text-subtitle",
      "text-dashboardCardTitle",
      "text-dashboardGridCardTitle"
    ],
    "passwordRequirement": [
      "text-caption",
      "text-passwordRequirement"
    ],
    "passwordRequirementSuccess": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementSuccess"
    ],
    "passwordRequirementError": [
      "text-caption",
      "text-passwordRequirement",
      "text-passwordRequirementError"
    ],
    "releaseAvailable": [
      "text-releaseAvailable"
    ],
    "openingHoursHeader": [
      "text-openingHoursHeader"
    ],
    "operatingHoursDay": [
      "text-operatingHoursDay"
    ],
    "groupingsCount": [
      "text-groupingsCount"
    ],
    "groupingsCountEmpty": [
      "text-groupingsCount",
      "text-groupingsCountEmpty"
    ],
    "formTitleCenter": [
      "text-title",
      "text-formTitle",
      "text-formTitleCenter"
    ],
    "valueGoodBattery": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueGoodBattery"
    ],
    "arrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue"
    ],
    "ruleTargetName": [
      "text-ruleTargetName"
    ],
    "rulePathSeparator": [
      "text-rulePathSeparator"
    ],
    "attributeTableUnitSuffix": [
      "text-attributeTableUnitSuffix"
    ],
    "selectorColumnValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-selectorColumnValue"
    ],
    "tablePill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-tablePill"
    ],
    "tablePillWarning": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-tablePillWarning"
    ],
    "tablePillSuccess": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-tablePillSuccess"
    ],
    "tableArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-tableArrayValue"
    ],
    "tablePillPrimary": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillPrimary",
      "text-tablePillPrimary"
    ],
    "tablePillError": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillError",
      "text-tablePillError"
    ],
    "tablePillStatus": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus",
      "text-tablePillStatus"
    ],
    "tablePillGood": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillGood",
      "text-tablePillGood"
    ],
    "tablePillAlert": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlert",
      "text-tablePillAlert"
    ],
    "deviceSelectorResults": [
      "text-deviceSelectorResults"
    ],
    "tempUserEditorTitle": [
      "text-title",
      "text-formTitle",
      "text-dialogTitle",
      "text-rootEditorTitle",
      "text-tempUserEditorTitle"
    ],
    "tempUserShareError": [
      "text-tempUserShareError"
    ],
    "aggregationEnumAggLabel": [
      "text-aggregationLabel",
      "text-aggregationEnumAggLabel"
    ],
    "inputCaption": [
      "text-caption",
      "text-inputCaption"
    ],
    "attributeDetailUnitSuffix": [
      "text-attributeDetailUnitSuffix"
    ],
    "attributePercentEditor": [
      "text-attributePercentEditor"
    ],
    "detailArrayValue": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-arrayValue",
      "text-detailArrayValue"
    ],
    "detailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad"
    ],
    "tvCollectionItemTitle": [
      "text-title",
      "text-tvCollectionItemTitle"
    ],
    "tvDetailLabelNoPad": [
      "text-bodySmall",
      "text-detailLabel",
      "text-tvDetailLabelNoPad"
    ],
    "tvDetailValueNoPad": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailValueNoPad",
      "text-tvDetailValueNoPad"
    ],
    "deviceCode": [
      "text-title",
      "text-deviceCode"
    ],
    "iconSuccessLarge": [
      "text-iconSuccessLarge"
    ],
    "titleLarge": [
      "text-title",
      "text-titleLarge"
    ],
    "bodyLarge": [
      "text-body",
      "text-bodyLarge"
    ],
    "altLoginMethod": [
      "text-captionSmall",
      "text-altLoginMethod"
    ],
    "altLoginMethodSmall": [
      "text-captionSmall",
      "text-altLoginMethod",
      "text-altLoginMethodSmall"
    ],
    "bodySmallBold": [
      "text-bodySmall",
      "text-bodySmallBold"
    ],
    "qrCodeInstruction": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter",
      "text-qrCodeInstruction"
    ],
    "bodySmallBoldCenter": [
      "text-bodySmall",
      "text-bodySmallBold",
      "text-bodySmallBoldCenter"
    ],
    "userCode": [
      "text-title",
      "text-userCode"
    ],
    "bodySmallCenter": [
      "text-bodySmall",
      "text-bodySmallCenter"
    ],
    "formBodyCenter": [
      "text-body",
      "text-formBody",
      "text-formBodyCenter"
    ],
    "errorTitle": [
      "text-errorTitle"
    ],
    "detailMultiTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-detailMultiTitle"
    ],
    "rsrcImageDetailTitle": [
      "text-title",
      "text-pageTitle",
      "text-rsrcImageDetailTitle"
    ],
    "detailRsrcTitle": [
      "text-detailRsrcTitle"
    ],
    "perPage": [
      "text-perPage"
    ],
    "layerToolbar": [
      "text-layerToolbar"
    ],
    "videoControlsLoader": [
      "text-videoControlsLoader"
    ],
    "videoControlsError": [
      "text-errorTitle",
      "text-videoControlsError"
    ],
    "videoControlsPoster": [
      "text-videoControlsPoster"
    ],
    "timelineScrubberTime": [
      "text-bodySmall",
      "text-bodySmallBold",
      "text-timelineScrubberTime"
    ],
    "timelineAxisTick": [
      "text-captionSmall",
      "text-timelineAxisTick"
    ],
    "timelineAxisSubTick": [
      "text-captionSmall",
      "text-timelineAxisTick",
      "text-timelineAxisSubTick"
    ],
    "videoControlsMessage": [
      "text-videoControlsMessage"
    ],
    "videoPlayerPill": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillStatus",
      "text-videoPlayerPill"
    ],
    "detailRsrcItemTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-detailRsrcItemTitle"
    ],
    "detailRsrcItemValue": [
      "text-bodySmall",
      "text-detailValue",
      "text-detailRsrcItemValue"
    ],
    "rsrcTimelineError": [
      "text-errorTitle",
      "text-videoControlsError",
      "text-rsrcTimelineError"
    ],
    "rsrcTimelineMessage": [
      "text-errorTitle",
      "text-videoControlsError",
      "text-rsrcTimelineMessage"
    ],
    "loadingSpinnerLarge": [
      "text-loadingSpinnerLarge"
    ],
    "loadingSpinnerLargeLight": [
      "text-loadingSpinnerLarge",
      "text-loadingSpinnerLargeLight"
    ],
    "pillOpen": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillOpen"
    ],
    "pillClosed": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillClosed"
    ],
    "tablePillOpen": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillWarning",
      "text-pillOpen",
      "text-tablePillOpen"
    ],
    "tablePillClosed": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillClosed",
      "text-tablePillClosed"
    ],
    "pillSourceUser": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillSourceUser"
    ],
    "tablePillSourceUser": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillSourceUser",
      "text-tablePillSourceUser"
    ],
    "pillSourceAi": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillSourceUser",
      "text-pillSourceAi"
    ],
    "tablePillSourceAi": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillSourceUser",
      "text-pillSourceAi",
      "text-tablePillSourceAi"
    ],
    "ogDetailValue": [
      "text-bodySmall",
      "text-detailValue",
      "text-ogDetailValue"
    ],
    "chartRolloverHeader": [
      "text-chartRolloverHeader"
    ],
    "lineDetailTitle": [
      "text-subtitle",
      "text-detailTitle",
      "text-lineDetailTitle"
    ],
    "lineDetailLabel": [
      "text-lineDetailLabel"
    ],
    "linePerformancePill": [
      "text-linePerformancePill"
    ],
    "moldHalfDetailValue": [
      "text-moldHalfDetailValue"
    ],
    "moldHalfStageDetailValue": [
      "text-moldHalfStageDetailValue"
    ],
    "workerCountTitle": [
      "text-captionBold",
      "text-workerCountTitle"
    ],
    "ganttRolloverValue": [
      "text-bodySmall",
      "text-detailValue",
      "text-ganttRolloverValue"
    ],
    "ganttRolloverHeader": [
      "text-subtitle",
      "text-editorTitle",
      "text-ganttRolloverHeader"
    ],
    "ganttRolloverOnTarget": [
      "text-bodySmall",
      "text-detailValue",
      "text-ganttRolloverValue",
      "text-ganttRolloverOnTarget"
    ],
    "ganttRolloverOverTarget": [
      "text-bodySmall",
      "text-detailValue",
      "text-ganttRolloverValue",
      "text-ganttRolloverOverTarget"
    ],
    "paceGood": [
      "text-paceGood"
    ],
    "paceBad": [
      "text-paceGood",
      "text-paceBad"
    ],
    "tagGood": [
      "__root__",
      "text-tagGood"
    ],
    "tagBad": [
      "__root__",
      "text-tagGood",
      "text-tagBad"
    ],
    "columnLabelCustom": [
      "text-columnLabel",
      "text-columnLabelCustom"
    ],
    "columnLabelCustomVertical": [
      "text-columnLabel",
      "text-columnLabelCustom",
      "text-columnLabelCustomVertical"
    ],
    "columnSubCustomVertical": [
      "text-columnLabel",
      "text-columnLabelCustom",
      "text-columnLabelCustomVertical",
      "text-columnSubCustomVertical"
    ],
    "columnHeaderCustom": [
      "text-columnHeaderCustom"
    ],
    "columnHeaderSubCustom": [
      "text-columnHeaderSubCustom"
    ],
    "tagNeutral": [
      "__root__",
      "text-tagGood",
      "text-tagNeutral"
    ],
    "captionSmallCustom": [
      "text-captionSmallBold",
      "text-captionSmallCustom"
    ],
    "paceCardHeader": [
      "text-paceCardHeader"
    ],
    "paceCardDetailContent": [
      "text-paceCardDetailContent"
    ],
    "paceCardDetailHeader": [
      "text-caption",
      "text-paceCardDetailHeader"
    ],
    "pace": [
      "text-paceGood",
      "text-pace"
    ],
    "overallPaceCardHeader": [
      "text-paceCardHeader",
      "text-overallPaceCardHeader"
    ],
    "factoryPaceCardHeader": [
      "text-paceCardHeader",
      "text-factoryPaceCardHeader"
    ],
    "factoryPaceGood": [
      "text-paceGood",
      "text-factoryPaceGood"
    ],
    "factoryPaceBad": [
      "text-paceGood",
      "text-paceBad",
      "text-factoryPaceBad"
    ],
    "factoryPaceCardDetailHeader": [
      "text-caption",
      "text-paceCardDetailHeader",
      "text-factoryPaceCardDetailHeader"
    ],
    "factoryOverallPace": [
      "text-factoryOverallPace"
    ],
    "overallPaceCardDetailHeader": [
      "text-caption",
      "text-paceCardDetailHeader",
      "text-overallPaceCardDetailHeader"
    ],
    "overallPaceCardDetailHeaderSmall": [
      "text-caption",
      "text-paceCardDetailHeader",
      "text-overallPaceCardDetailHeader",
      "text-overallPaceCardDetailHeaderSmall"
    ],
    "overallPaceCardDetailContent": [
      "text-paceCardDetailContent",
      "text-overallPaceCardDetailContent"
    ],
    "factoryPaceCardDetailContent": [
      "text-paceCardDetailContent",
      "text-factoryPaceCardDetailContent"
    ],
    "factoryNoCollectionHeader": [
      "text-factoryNoCollectionHeader"
    ],
    "factoryNoCollectionBody": [
      "text-factoryNoCollectionBody"
    ],
    "mobilePaceCardHeader": [
      "text-mobilePaceCardHeader"
    ],
    "mobilePaceCardBigHeader": [
      "__root__",
      "text-mobilePaceCardBigHeader"
    ],
    "mobilePaceGood": [
      "text-paceGood",
      "text-factoryPaceGood",
      "text-mobilePaceGood"
    ],
    "mobilePaceBad": [
      "text-paceGood",
      "text-paceBad",
      "text-factoryPaceBad",
      "text-mobilePaceBad"
    ],
    "mobileTagGood": [
      "__root__",
      "text-tagGood",
      "text-mobileTagGood"
    ],
    "mobileTagBad": [
      "__root__",
      "text-tagGood",
      "text-tagBad",
      "text-mobileTagBad"
    ],
    "mobileTagNeutral": [
      "__root__",
      "text-tagGood",
      "text-tagNeutral",
      "text-mobileTagNeutral"
    ],
    "mobileSmallPaceGood": [
      "text-paceGood",
      "text-factoryPaceGood",
      "text-mobilePaceGood",
      "text-mobileSmallPaceGood"
    ],
    "mobileSmallPaceBad": [
      "text-paceGood",
      "text-paceBad",
      "text-factoryPaceBad",
      "text-mobilePaceBad",
      "text-mobileSmallPaceBad"
    ],
    "mobileNoCollectionHeader": [
      "text-factoryNoCollectionHeader",
      "text-mobileNoCollectionHeader"
    ],
    "mobileNoCollectionBody": [
      "text-factoryNoCollectionBody",
      "text-mobileNoCollectionBody"
    ],
    "pillInProgress": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillInProgress"
    ],
    "vaueGood": [
      "text-vaueGood"
    ],
    "valueInProgress": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueInProgress"
    ],
    "valueNew": [
      "text-columnLabel",
      "text-columnValue",
      "text-value",
      "text-valueNew"
    ],
    "tablePillInProgress": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillInProgress",
      "text-tablePillInProgress"
    ],
    "plyLayerTitle": [
      "text-plyLayerTitle"
    ],
    "plyLayerLastUpdated": [
      "text-plyLayerLastUpdated"
    ],
    "plyLayerCurrentTitle": [
      "text-plyLayerCurrentTitle"
    ],
    "plyLayerCurrentId": [
      "text-plyLayerCurrentId"
    ],
    "plyLayerPill": [
      "text-plyLayerPill"
    ],
    "plyLayerPillSuccess": [
      "text-plyLayerPill",
      "text-plyLayerPillSuccess"
    ],
    "plyLayerPillSuccessLarge": [
      "text-plyLayerPill",
      "text-plyLayerPillSuccess",
      "text-plyLayerPillSuccessLarge"
    ],
    "plyLayerPillError": [
      "text-plyLayerPill",
      "text-plyLayerPillError"
    ],
    "plyLayerPillErrorLarge": [
      "text-plyLayerPill",
      "text-plyLayerPillError",
      "text-plyLayerPillErrorLarge"
    ],
    "plyLayerPreviousHeader": [
      "text-plyLayerPreviousHeader"
    ],
    "plyLayerPillLarge": [
      "text-plyLayerPill",
      "text-plyLayerPillLarge"
    ],
    "plyLayerPillInProgress": [
      "text-plyLayerPill",
      "text-plyLayerPillInProgress"
    ],
    "plyLayerPillInProgressLarge": [
      "text-plyLayerPill",
      "text-plyLayerPillInProgress",
      "text-plyLayerPillInProgressLarge"
    ],
    "plyLayerPreviousId": [
      "text-plyLayerCurrentId",
      "text-plyLayerPreviousId"
    ],
    "plyLayerNoDataTitle": [
      "text-plyLayerNoDataTitle"
    ],
    "plyLayerNoDataSubtitle": [
      "text-plyLayerNoDataSubtitle"
    ],
    "paceIdle": [
      "__root__",
      "text-paceIdle"
    ],
    "delayDescriptionTitle": [
      "text-delayDescriptionTitle"
    ],
    "delayDescriptionSub": [
      "text-delayDescriptionSub"
    ],
    "tableHeader": [
      "text-subtitle",
      "text-tableHeader"
    ],
    "mobileSmallPaceIdle": [
      "text-mobileSmallPaceIdle"
    ],
    "plyLayersSubtitle": [
      "text-plyLayerTitle",
      "text-plyLayersSubtitle"
    ],
    "plyLayerStatsSubtitle": [
      "text-plyLayerTitle",
      "text-plyLayersSubtitle",
      "text-plyLayerStatsSubtitle"
    ],
    "pdfHeaderTitle": [
      "text-pdfHeaderTitle"
    ],
    "pdfHeaderSub": [
      "text-pdfHeaderSub"
    ],
    "pdfTableHeader": [
      "text-pdfTableHeader"
    ],
    "factoryPaceIdle": [
      "__root__",
      "text-factoryPaceIdle"
    ],
    "pillAlertEnabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillSuccess",
      "text-pillAlertEnabled"
    ],
    "pillAlertDisabled": [
      "text-columnLabel",
      "text-columnValue",
      "text-pill",
      "text-pillAlertDisabled"
    ],
    "columnValueFixedWidth": [
      "text-columnLabel",
      "text-columnValue",
      "text-columnValueFixedWidth"
    ],
    "plyLayerPillTimeout": [
      "text-plyLayerPillTimeout"
    ],
    "plyLayerPillUnverifiedTimeout": [
      "text-plyLayerPill",
      "text-plyLayerPillUnverifiedTimeout"
    ],
    "plyLayer": [
      "text-plyLayer"
    ],
    "plyLayerShopFloorPill": [
      "text-plyLayerShopFloorPill"
    ],
    "plyLayerShopFloorPillSuccess": [
      "text-plyLayerShopFloorPill",
      "text-plyLayerShopFloorPillSuccess"
    ],
    "plyLayerShopFloorPillError": [
      "text-plyLayerShopFloorPill",
      "text-plyLayerShopFloorPillError"
    ],
    "plyLayerShopFloorPillUnverifiedTimeout": [
      "text-plyLayerShopFloorPill",
      "text-plyLayerShopFloorPillUnverifiedTimeout"
    ],
    "plyLayerShopFloorPillInProgress": [
      "text-plyLayerShopFloorPill",
      "text-plyLayerShopFloorPillInProgress"
    ],
    "loadTimeoutError": [
      "text-subtitle",
      "text-loadTimeoutError"
    ]
  },
  "props": {
    "default": {
      "iconOpts": null
    },
    "title": {
      "iconOpts": null
    },
    "subtitle": {
      "iconOpts": null
    },
    "body": {
      "iconOpts": null
    },
    "bodySmall": {
      "iconOpts": null
    },
    "caption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "captionSmall": {
      "iconOpts": null
    },
    "navLogoLabel": {
      "iconOpts": null
    },
    "pageTitle": {
      "iconOpts": null
    },
    "sectionTitle": {
      "iconOpts": null
    },
    "sectionBody": {
      "iconOpts": null
    },
    "cardTitle": {
      "iconOpts": null
    },
    "formTitle": {
      "iconOpts": null
    },
    "formSubtitle": {
      "iconOpts": null
    },
    "formBody": {
      "iconOpts": null
    },
    "listItemTitle": {
      "iconOpts": null
    },
    "listItemSubtitle": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "inputCaptionSmall": {
      "iconOpts": null
    },
    "inputCaptionSmallError": {
      "iconOpts": null
    },
    "loginWarning": {
      "iconOpts": null
    },
    "mobileMapTitle": {
      "iconOpts": null
    },
    "mobileTitle": {
      "iconOpts": null
    },
    "captionBold": {
      "iconOpts": null
    },
    "captionSmallBold": {
      "iconOpts": null
    },
    "toastTitle": {
      "iconOpts": null
    },
    "toastMsg": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "detailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "detailLabel": {
      "iconOpts": null
    },
    "detailValue": {
      "iconOpts": null
    },
    "detailSuffix": {
      "iconOpts": null
    },
    "screenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-ScreenIconBackground)",
          "borderRadius": "2px",
          "color": "var(--color-ScreenIcon)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "dialogTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "sideNav": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "height": "0px",
        "width": "0px"
      },
      "useEllipsis": true
    },
    "loginLogo": {
      "iconOpts": null,
      "icon": "https://storage.googleapis.com/tpi-ui-assets/TPI%20Logos/tpi-assure-dark.svg",
      "imageOpts": {
        "height": "56px"
      }
    },
    "listDetailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "mobileUserNavBar": {
      "iconOpts": null,
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "groupTitle": {
      "iconOpts": null
    },
    "dashboardCardTitle": {
      "iconOpts": null
    },
    "dashboardCardEditorTitle": {
      "iconOpts": null
    },
    "rootEditorTitle": {
      "iconOpts": null,
      "imageOpts": {
        "height": "32"
      }
    },
    "actionBar": {
      "iconOpts": null
    },
    "sideNavBarHeader": {
      "iconOpts": null
    },
    "networkOffline": {
      "iconOpts": null
    },
    "sideNavSmall": {
      "iconOpts": {
        "style": {
          "background": "0px",
          "fontSize": "0px",
          "padding": "0px"
        }
      },
      "imageOpts": {
        "width": "0"
      },
      "useEllipsis": true
    },
    "linearViewHeaderCell1": {
      "iconOpts": null
    },
    "linearViewHeaderCell2": {
      "iconOpts": null
    },
    "pairingErrorSubtitle": {
      "iconOpts": null
    },
    "bodyCentered": {
      "iconOpts": null
    },
    "resendSuccess": {
      "iconOpts": null,
      "icon": "https://molten-ui-assets.storage.googleapis.com/two-step-success.png",
      "imageOpts": {
        "height": "18px",
        "width": "18px"
      }
    },
    "twoFactorWarning": {
      "iconOpts": {
        "style": {
          "color": "#E9354D",
          "fontSize": "18px"
        }
      },
      "icon": "lv lv-system-error"
    },
    "pill": {
      "iconOpts": null
    },
    "pillPrimary": {
      "iconOpts": null
    },
    "pillSuccess": {
      "iconOpts": null
    },
    "pillWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "pillError": {
      "iconOpts": null
    },
    "resendCodeSuccess": {
      "iconOpts": {
        "style": {
          "color": "#15b982",
          "fontSize": "20px"
        }
      },
      "icon": "@icon:success"
    },
    "twoStepTitle": {
      "iconOpts": null
    },
    "hint": {
      "iconOpts": null
    },
    "columnValue": {
      "iconOpts": null
    },
    "columnLabel": {
      "iconOpts": null
    },
    "conditionTitle": {
      "iconOpts": null
    },
    "missingRelTitle": {
      "iconOpts": null
    },
    "expressionParen": {
      "iconOpts": null
    },
    "operatingHoursTitle": {
      "iconOpts": null
    },
    "hintSmall": {
      "iconOpts": null
    },
    "aggregationTitle": {
      "iconOpts": null
    },
    "aggregationLabel": {
      "iconOpts": null
    },
    "aggregationValue": {
      "iconOpts": null
    },
    "overrideExample": {
      "iconOpts": null
    },
    "editorTitle": {
      "iconOpts": null
    },
    "conditionAttributeLabel": {
      "iconOpts": null
    },
    "info": {
      "iconOpts": {
        "style": {
          "color": "#0d49e4",
          "fontSize": "14px"
        }
      },
      "icon": "@icon:info-filled"
    },
    "conditionPropertyComparatorValue": {
      "iconOpts": null
    },
    "comparator": {
      "iconOpts": null
    },
    "tagError": {
      "iconOpts": null
    },
    "captionCurrent": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "tableConditionAttributeLabel": {
      "iconOpts": null
    },
    "mobileNavSubtitle": {
      "iconOpts": {
        "style": {
          "color": "var(--color-white)"
        }
      },
      "imageOpts": {
        "height": "24px",
        "width": "24px"
      }
    },
    "navSecondaryMobileTitle": {
      "iconOpts": null
    },
    "navSecondaryMobileHeader": {
      "iconOpts": null
    },
    "mobileScreenTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      }
    },
    "mobileOptNavTitle": {
      "iconOpts": null
    },
    "mobileNavBarHeader": {
      "iconOpts": null
    },
    "ruleTrigger": {
      "iconOpts": null
    },
    "ruleBlockTitle": {
      "iconOpts": {
        "style": {
          "background": "",
          "color": "",
          "fontSize": "16px",
          "padding": ""
        }
      },
      "imageOpts": {
        "width": "24px"
      }
    },
    "ruleBlockDescription": {
      "iconOpts": null
    },
    "captionLeft": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "linkTable": {
      "iconOpts": null
    },
    "pillStatus": {
      "iconOpts": null
    },
    "pillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "pillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "value": {
      "iconOpts": null
    },
    "valueGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "valueAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-regular fa-circle-exclamation"
    },
    "valueOffline": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base500)"
        }
      },
      "icon": "fa-solid fa-wifi-slash"
    },
    "valueLowBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-battery-low"
    },
    "dashboardGridCardTitle": {
      "iconOpts": null
    },
    "passwordRequirement": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base200)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-minus"
    },
    "passwordRequirementSuccess": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-check"
    },
    "passwordRequirementError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "imageOpts": {
        "width": "24px"
      },
      "icon": "fa fa-fw fa-close"
    },
    "releaseAvailable": {
      "iconOpts": null
    },
    "openingHoursHeader": {
      "iconOpts": null
    },
    "operatingHoursDay": {
      "iconOpts": null
    },
    "groupingsCount": {
      "iconOpts": null
    },
    "groupingsCountEmpty": {
      "iconOpts": null
    },
    "formTitleCenter": {
      "iconOpts": null
    },
    "valueGoodBattery": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-regular fa-battery-full"
    },
    "arrayValue": {
      "iconOpts": null
    },
    "ruleTargetName": {
      "iconOpts": null
    },
    "rulePathSeparator": {
      "iconOpts": null
    },
    "attributeTableUnitSuffix": {
      "iconOpts": null
    },
    "selectorColumnValue": {
      "iconOpts": null
    },
    "tablePill": {
      "iconOpts": null
    },
    "tablePillWarning": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "tablePillSuccess": {
      "iconOpts": null
    },
    "tableArrayValue": {
      "iconOpts": null
    },
    "tablePillPrimary": {
      "iconOpts": null
    },
    "tablePillError": {
      "iconOpts": null
    },
    "tablePillStatus": {
      "iconOpts": null
    },
    "tablePillGood": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success500)"
        }
      },
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillAlert": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "deviceSelectorResults": {
      "iconOpts": null
    },
    "tempUserEditorTitle": {
      "iconOpts": {
        "style": {
          "background": "var(--color-brand025)",
          "borderRadius": "2px",
          "color": "var(--color-brand500)",
          "padding": "4px"
        }
      },
      "imageOpts": {
        "height": "32"
      }
    },
    "tempUserShareError": {
      "iconOpts": {
        "style": {
          "color": "var( --color-danger500 )",
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "aggregationEnumAggLabel": {
      "iconOpts": null
    },
    "inputCaption": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "attributeDetailUnitSuffix": {
      "iconOpts": null
    },
    "attributePercentEditor": {
      "iconOpts": null
    },
    "detailArrayValue": {
      "iconOpts": null
    },
    "detailValueNoPad": {
      "iconOpts": null
    },
    "tvCollectionItemTitle": {
      "iconOpts": null
    },
    "tvDetailLabelNoPad": {
      "iconOpts": null
    },
    "tvDetailValueNoPad": {
      "iconOpts": null
    },
    "deviceCode": {
      "iconOpts": null
    },
    "iconSuccessLarge": {
      "iconOpts": null
    },
    "titleLarge": {
      "iconOpts": null
    },
    "bodyLarge": {
      "iconOpts": null
    },
    "altLoginMethod": {
      "iconOpts": null
    },
    "altLoginMethodSmall": {
      "iconOpts": null
    },
    "bodySmallBold": {
      "iconOpts": null
    },
    "qrCodeInstruction": {
      "iconOpts": null
    },
    "bodySmallBoldCenter": {
      "iconOpts": null
    },
    "userCode": {
      "iconOpts": null
    },
    "bodySmallCenter": {
      "iconOpts": null
    },
    "formBodyCenter": {
      "iconOpts": null
    },
    "errorTitle": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "detailMultiTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "rsrcImageDetailTitle": {
      "iconOpts": null
    },
    "detailRsrcTitle": {
      "iconOpts": null
    },
    "perPage": {
      "iconOpts": null
    },
    "layerToolbar": {
      "iconOpts": null
    },
    "videoControlsLoader": {
      "iconOpts": null,
      "icon": "fa-light fa-fw fa-spinner-third fa-spin"
    },
    "videoControlsError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "videoControlsPoster": {
      "iconOpts": null,
      "icon": "fa-thin fa-circle-play fa-fw"
    },
    "timelineScrubberTime": {
      "iconOpts": null
    },
    "timelineAxisTick": {
      "iconOpts": null
    },
    "timelineAxisSubTick": {
      "iconOpts": null
    },
    "videoControlsMessage": {
      "iconOpts": null
    },
    "videoPlayerPill": {
      "iconOpts": null,
      "icon": "fa-solid fa-fw fa-video"
    },
    "detailRsrcItemTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      }
    },
    "detailRsrcItemValue": {
      "iconOpts": null
    },
    "rsrcTimelineError": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "rsrcTimelineMessage": {
      "iconOpts": {
        "style": {
          "color": "var(--color-danger500)"
        }
      },
      "icon": "fa"
    },
    "loadingSpinnerLarge": {
      "iconOpts": null,
      "icon": "fa fa-fw fa-spinner fa-spin fa-3x"
    },
    "loadingSpinnerLargeLight": {
      "iconOpts": null,
      "icon": "fa fa-fw fa-spinner fa-spin fa-3x"
    },
    "pillOpen": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "pillClosed": {
      "iconOpts": null,
      "icon": "fa-solid fa-circle-check"
    },
    "tablePillOpen": {
      "iconOpts": {
        "style": {
          "background": "var(--color-warning050)",
          "color": "var(--color-warning500)"
        }
      },
      "icon": "fa-solid fa-circle-exclamation"
    },
    "tablePillClosed": {
      "iconOpts": null,
      "icon": "fa-solid fa-circle-check"
    },
    "pillSourceUser": {
      "iconOpts": {
        "style": {
          "color": "var(--color-secondaryBrand500)"
        }
      },
      "icon": "fa-solid fa-user"
    },
    "tablePillSourceUser": {
      "iconOpts": {
        "style": {
          "color": "#194EDC"
        }
      },
      "icon": "fa-solid fa-user"
    },
    "pillSourceAi": {
      "iconOpts": {
        "style": {
          "color": "var(--color-secondaryBrand500)"
        }
      },
      "icon": "fa-solid fa-sparkles"
    },
    "tablePillSourceAi": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-sparkles"
    },
    "ogDetailValue": {
      "iconOpts": null
    },
    "chartRolloverHeader": {
      "iconOpts": null
    },
    "lineDetailTitle": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-molds"
    },
    "lineDetailLabel": {
      "iconOpts": null
    },
    "linePerformancePill": {
      "iconOpts": {
        "style": {
          "color": "var( --color-base700 )",
          "fontSize": "12px"
        }
      }
    },
    "moldHalfDetailValue": {
      "iconOpts": null
    },
    "moldHalfStageDetailValue": {
      "iconOpts": null
    },
    "workerCountTitle": {
      "iconOpts": null
    },
    "ganttRolloverValue": {
      "iconOpts": null
    },
    "ganttRolloverHeader": {
      "iconOpts": null
    },
    "ganttRolloverOnTarget": {
      "iconOpts": {
        "style": {
          "color": "#3a7f5d",
          "fontSize": "14px"
        }
      },
      "icon": "fa-kit fa-lv-check"
    },
    "ganttRolloverOverTarget": {
      "iconOpts": {
        "style": {
          "color": "#8f323b",
          "fontSize": "14px"
        }
      },
      "icon": "fa-kit fa-lv-cancel"
    },
    "paceGood": {
      "iconOpts": {
        "style": {
          "fontSize": "60px"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "paceBad": {
      "iconOpts": {
        "style": {
          "fontSize": "60px"
        }
      },
      "icon": "fa-solid fa-xmark"
    },
    "tagGood": {},
    "tagBad": {},
    "columnLabelCustom": {
      "iconOpts": null
    },
    "columnLabelCustomVertical": {
      "iconOpts": null
    },
    "columnSubCustomVertical": {
      "iconOpts": null
    },
    "columnHeaderCustom": {
      "iconOpts": null
    },
    "columnHeaderSubCustom": {
      "iconOpts": null
    },
    "tagNeutral": {},
    "captionSmallCustom": {
      "iconOpts": null
    },
    "paceCardHeader": {
      "iconOpts": null
    },
    "paceCardDetailContent": {
      "iconOpts": null
    },
    "paceCardDetailHeader": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "pace": {
      "iconOpts": {
        "style": {
          "fontSize": "60px"
        }
      },
      "icon": ""
    },
    "overallPaceCardHeader": {
      "iconOpts": null
    },
    "factoryPaceCardHeader": {
      "iconOpts": null
    },
    "factoryPaceGood": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "factoryPaceBad": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-xmark"
    },
    "factoryPaceCardDetailHeader": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "factoryOverallPace": {
      "iconOpts": null
    },
    "overallPaceCardDetailHeader": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "overallPaceCardDetailHeaderSmall": {
      "iconOpts": null,
      "imageOpts": {
        "width": "24px"
      }
    },
    "overallPaceCardDetailContent": {
      "iconOpts": null
    },
    "factoryPaceCardDetailContent": {
      "iconOpts": null
    },
    "factoryNoCollectionHeader": {
      "iconOpts": null
    },
    "factoryNoCollectionBody": {
      "iconOpts": null
    },
    "mobilePaceCardHeader": {
      "iconOpts": null
    },
    "mobilePaceCardBigHeader": {},
    "mobilePaceGood": {
      "iconOpts": {
        "style": {
          "fontSize": "24px"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "mobilePaceBad": {
      "iconOpts": {
        "style": {
          "fontSize": "18px"
        }
      },
      "icon": "fa-solid fa-xmark"
    },
    "mobileTagGood": {},
    "mobileTagBad": {},
    "mobileTagNeutral": {},
    "mobileSmallPaceGood": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "icon": "fa-solid fa-check"
    },
    "mobileSmallPaceBad": {
      "iconOpts": {
        "style": {
          "fontSize": "14px"
        }
      },
      "icon": "fa-solid fa-xmark"
    },
    "mobileNoCollectionHeader": {
      "iconOpts": null
    },
    "mobileNoCollectionBody": {
      "iconOpts": null
    },
    "pillInProgress": {
      "iconOpts": null,
      "icon": "fa-solid fa-spinner"
    },
    "vaueGood": {
      "iconOpts": null
    },
    "valueInProgress": {
      "iconOpts": {
        "style": {
          "color": "var(--color-brand500)"
        }
      },
      "icon": "fa-solid fa-spinner"
    },
    "valueNew": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base500)"
        }
      },
      "icon": "fa-solid fa-exclamation"
    },
    "tablePillInProgress": {
      "iconOpts": null,
      "icon": "fa-solid fa-spinner"
    },
    "plyLayerTitle": {
      "iconOpts": null
    },
    "plyLayerLastUpdated": {
      "iconOpts": null
    },
    "plyLayerCurrentTitle": {
      "iconOpts": null
    },
    "plyLayerCurrentId": {
      "iconOpts": null
    },
    "plyLayerPill": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "plyLayerPillSuccess": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa fa-fw fa-check"
    },
    "plyLayerPillSuccessLarge": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa fa-fw fa-check"
    },
    "plyLayerPillError": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa fa-fw fa-close"
    },
    "plyLayerPillErrorLarge": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa fa-fw fa-close"
    },
    "plyLayerPreviousHeader": {
      "iconOpts": null
    },
    "plyLayerPillLarge": {
      "iconOpts": {
        "style": {
          "color": "",
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "plyLayerPillInProgress": {
      "iconOpts": {
        "style": {
          "color": "#394756",
          "fontSize": "60cqh"
        }
      },
      "icon": "fa fa-fw fa-spinner fa-spin"
    },
    "plyLayerPillInProgressLarge": {
      "iconOpts": {
        "style": {
          "color": "#394756",
          "fontSize": "60cqh"
        }
      },
      "icon": "fa fa-fw fa-spinner fa-spin"
    },
    "plyLayerPreviousId": {
      "iconOpts": null
    },
    "plyLayerNoDataTitle": {
      "iconOpts": null
    },
    "plyLayerNoDataSubtitle": {
      "iconOpts": null
    },
    "paceIdle": {
      "iconOpts": {
        "style": {
          "fontSize": "32px"
        }
      }
    },
    "delayDescriptionTitle": {
      "iconOpts": null
    },
    "delayDescriptionSub": {
      "iconOpts": null
    },
    "tableHeader": {
      "iconOpts": null
    },
    "mobileSmallPaceIdle": {
      "iconOpts": null
    },
    "plyLayersSubtitle": {
      "iconOpts": null
    },
    "plyLayerStatsSubtitle": {
      "iconOpts": null
    },
    "pdfHeaderTitle": {
      "iconOpts": null
    },
    "pdfHeaderSub": {
      "iconOpts": null
    },
    "pdfTableHeader": {
      "iconOpts": null
    },
    "factoryPaceIdle": {},
    "pillAlertEnabled": {
      "iconOpts": {
        "style": {
          "color": "var(--color-success700)"
        }
      },
      "icon": "fa-solid fa-bell"
    },
    "pillAlertDisabled": {
      "iconOpts": {
        "style": {
          "color": "var(--color-base500 )"
        }
      },
      "icon": "fa-solid fa-bell-slash"
    },
    "columnValueFixedWidth": {
      "iconOpts": null
    },
    "plyLayerPillTimeout": {
      "iconOpts": null
    },
    "plyLayerPillUnverifiedTimeout": {
      "iconOpts": {
        "style": {
          "fontSize": ""
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "plyLayer": {
      "iconOpts": null
    },
    "plyLayerShopFloorPill": {
      "iconOpts": {
        "style": {
          "color": "currentColor"
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "plyLayerShopFloorPillSuccess": {
      "iconOpts": {
        "style": {
          "color": "currentColor"
        }
      },
      "icon": "fa fa-fw fa-check"
    },
    "plyLayerShopFloorPillError": {
      "iconOpts": {
        "style": {
          "color": "currentColor"
        }
      },
      "icon": "fa fa-fw fa-close"
    },
    "plyLayerShopFloorPillUnverifiedTimeout": {
      "iconOpts": {
        "style": {
          "color": "currentColor"
        }
      },
      "icon": "fa-kit fa-lv-exclamation-short"
    },
    "plyLayerShopFloorPillInProgress": {
      "iconOpts": {
        "style": {
          "color": "#394756",
          "fontSize": "25px"
        }
      },
      "icon": "fa fa-fw fa-spinner fa-spin"
    },
    "loadTimeoutError": {
      "iconOpts": null
    }
  }
}